// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__wkXM5","title":"InfoRow_title__U-Efw"};